import React from "react";

import FormContext from "./FormContext";

class Form extends React.Component {
  constructor(props) {
    super(props);

    const fields = {};
    if (props.defaultValues) {
      for (const [key, value] of Object.entries(props.defaultValues)) {
        fields[key] = { value };
      }
    }

    this.state = {
      fields,
      set: this.set.bind(this),
      get: this.get.bind(this),
      setError: this.setError.bind(this),
    };

    if (props.unsafe_valueSetter) {
      props.unsafe_valueSetter((field, value) => {
        this.set(field, value);
      });
    }
  }

  set(name, value) {
    let error = "";
    try {
      error = this.props.validation[name](value);
    } catch (e) {}
    // Functional updates: React batches the updates of one event, so `this.state` is still the old
    // state here and a later set()/setError() in the same event would overwrite this one.
    this.setState((state) => ({
      fields: {
        ...state.fields,
        [name]: {
          value,
          error,
        },
      },
    }));
  }

  get(name) {
    return this.state.fields[name] || {};
  }

  setError(name, error) {
    this.setState((state) => ({
      fields: {
        ...state.fields,
        [name]: {
          ...state.fields[name],
          error,
        },
      },
    }));
  }

  hasErrors() {
    let hasError = false;

    // Only check errors for fields that have a value (i.e., connected to a form input via set()).
    // Fields set only via setError() (e.g. from external state) have no 'value' key and are skipped
    // to avoid stale validation errors permanently blocking future submissions.
    for (const fieldName in this.state.fields) {
      const field = this.state.fields[fieldName];
      if (field.error && Object.prototype.hasOwnProperty.call(field, "value")) {
        hasError = true;
        break;
      }
    }

    if (hasError) {
      return true;
    }

    // Then check validation functions
    for (const [name, validationFn] of Object.entries(this.props.validation)) {
      const error = validationFn(this.state.fields[name]?.value);
      if (error) {
        this.setError(name, error);
        hasError = true;
        break;
      }
    }

    return hasError;
  }

  async submit() {
    if (!this.hasErrors()) {
      const errors = await this.props?.onSubmit(this.values());
      if (errors) {
        for (const [field, error] of Object.entries(errors)) {
          this.setError(field, error);
        }
      }
    }
  }

  values() {
    const ret = {};
    for (const [name, value] of Object.entries(this.state.fields)) {
      ret[name] = value.value;
    }
    return ret;
  }

  render() {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          try {
            this.submit(e);
          } catch (e) {
            console.log(e);
          }
          return false;
        }}
      >
        <FormContext.Provider value={this.state}>{this.props.children}</FormContext.Provider>
      </form>
    );
  }
}

Form.defaultProps = {
  validation: {},
};

Form.contextType = FormContext;

export default Form;
